import styled from 'styled-components';

export const StyledCalendarContainer = styled.div`
  background-color: #ffffff;
  margin: 20px;
  border-color: var(--ion-color-light-shade);
  border-style: double;
`;
